export const DEFAULT_CARRIER_META = {
  usps_rural: { label: "USPS Rural Mail", shortLabel: "USPS Mail", color: "#004b87", bg: "#e8f1fa" },
  usps: { label: "USPS", shortLabel: "USPS", color: "#004b87", bg: "#e8f1fa" },
  ups: { label: "UPS", shortLabel: "UPS", color: "#351c15", bg: "#f5ebe6" },
  fedex: { label: "FedEx", shortLabel: "FedEx", color: "#4d148c", bg: "#f3ebfa" },
  dhl: { label: "DHL", shortLabel: "DHL", color: "#b8860b", bg: "#fff8e1" },
  amazon: { label: "Amazon", shortLabel: "Amazon", color: "#146eb4", bg: "#e8f4fc" },
  unknown: { label: "Unknown carrier", shortLabel: "Unknown", color: "#475569", bg: "#f1f5f9" },
};

export const CARRIER_OPTIONS = ["usps_rural", "usps", "ups", "fedex", "dhl", "amazon", "unknown"];

export const DASHBOARD_CARRIERS = ["usps_rural", "ups", "fedex", "dhl", "amazon"];

export const RING_DEVELOPER_CONSOLE_URL = "https://developer.amazon.com/ring/console";

export const RING_SETUP_STEPS = [
  "In the Ring Developer Portal, open your Nantahala Mountain Resort app → Test → Log in with Ring.",
  "On your phone: Ring app → Menu → Integrations → Nantahala Mountain Resort → select gate and mailbox cameras → Confirm.",
  "Return to this page and click Finish linking (within about 10 minutes).",
];

export function formatMailboxTime(iso) {
  if (!iso) return "—";
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return "—";
  return date.toLocaleString("en-US", {
    timeZone: "America/New_York",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
}

export function formatMailboxDate(dateKey) {
  if (!dateKey) return "—";
  const [year, month, day] = dateKey.split("-").map(Number);
  const date = new Date(year, month - 1, day);
  return date.toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric" });
}

export function formatLastDeliveredDate(iso) {
  if (!iso) return "No delivery yet";
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return "No delivery yet";
  return date.toLocaleDateString("en-US", {
    timeZone: "America/New_York",
    weekday: "short",
    month: "short",
    day: "numeric",
  });
}

export function carrierMetaFor(id, carrierMeta) {
  const key = id || "unknown";
  return carrierMeta?.[key] || DEFAULT_CARRIER_META[key] || DEFAULT_CARRIER_META.unknown;
}

export function mailboxDevicesFromMonitoring(monitoring) {
  if (!monitoring || typeof monitoring !== "object") return [];
  const byId = new Map();
  for (const device of Array.isArray(monitoring.devices) ? monitoring.devices : []) {
    if (device?.deviceId) byId.set(device.deviceId, device);
  }
  for (const rawId of Array.isArray(monitoring.deviceIds) ? monitoring.deviceIds : []) {
    if (typeof rawId !== "string" || !rawId.trim()) continue;
    const deviceId = rawId.trim();
    if (!byId.has(deviceId)) {
      byId.set(deviceId, { deviceId, name: deviceId, kind: "camera" });
    }
  }
  return [...byId.values()];
}

export function callableErrorMessage(err) {
  if (!err) return "Unknown error";
  if (typeof err.message === "string" && err.message.trim()) return err.message;
  if (typeof err.details === "string" && err.details.trim()) return err.details;
  return "Request failed. Please try again.";
}

export function normalizeCarrierKey(carrier) {
  if (carrier === "usps") return "usps_rural";
  return carrier;
}

export function lastDeliveryByCarrier(history, carrierIds = DASHBOARD_CARRIERS) {
  const latest = {};
  for (const id of carrierIds) {
    latest[id] = null;
  }

  for (const day of history || []) {
    for (const delivery of day.deliveries || []) {
      if (delivery.adminStatus === "rejected") continue;
      const raw = delivery.displayCarrier || delivery.confirmedCarrier || delivery.carrier;
      const carrier = normalizeCarrierKey(raw);
      if (!carrierIds.includes(carrier) || !delivery.deliveredAt) continue;
      const prev = latest[carrier];
      if (!prev || Date.parse(delivery.deliveredAt) > Date.parse(prev.deliveredAt)) {
        latest[carrier] = {
          deliveredAt: delivery.deliveredAt,
          dateKey: day.dateKey,
          timeLabel: formatMailboxTime(delivery.deliveredAt),
          dateLabel: formatLastDeliveredDate(delivery.deliveredAt),
        };
      }
    }
  }

  return latest;
}

export function visibleDeliveries(deliveries, includePending = true) {
  return (deliveries || []).filter((d) => {
    if (d.adminStatus === "rejected") return false;
    if (!includePending && d.adminStatus === "pending") return false;
    return true;
  });
}